<div [formGroup]="form">

  <div class="row">
    <div class="col-12 col-lg-4">
      <!--GATEWAYS-->
      <div class="form-group">
        <label for="cloudPlug" translate
          [innerText]="isMachineryGroupsConfigs ? 'Gateways for machinery group' : 'Gateways for machine'">
        </label>
        <scitis-required-field-indicator></scitis-required-field-indicator>
        @if (isMachineryGroupsConfigs) {
          <span class="text-info ml-1">
            <em class="fa-solid fa-circle-info"
            [ngbTooltip]="'You have to type something first to trigger the search.' | translate"></em>
          </span>
        }
        @if (isLoadingCloudPlugs) {
          <span class="fa-solid fa-spinner fa-spin ml-2"></span>
        }

        @if (isMachineryGroupsConfigs) {
          <scitis-search-select #searchSelectInput
            formControlName="cloudPlug"
            [ngClass]="{ 'is-invalid': formControls.cloudPlug.touched && formControls.cloudPlug.errors }"
            (searchTermEmit)="loadGateways($event)"
            (optionSelected)="onLoadSignalsForCloudPlug($event)"
            (focusOut)="onFocusOut(); formControls.cloudPlug.markAsTouched()"
            [options]="cloudPlugs" [placeholder]="'Search gateway'">
          </scitis-search-select>
        } @else {
          <ng-select (change)="onLoadSignalsForCloudPlug($event)" (focusout)="onFocusOut()"
            [items]="cloudPlugs"
            [ngClass]="{ 'is-invalid': formControls.cloudPlug.touched && formControls.cloudPlug.errors }"
            bindLabel="name" bindValue="id" formControlName="cloudPlug" id="cloudPlug"
            placeholder="Select gateway">
          </ng-select>
        }


        @if (formControls.cloudPlug.touched && formControls.cloudPlug.errors) {
          <div class="invalid-feedback">
            @if (formControls.cloudPlug.errors.required) {
              <span translate>Gateway selection required</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <!--SIGNAL EDGE-->
      <div class="form-group">
        <label for="signalEdge" translate>Signal edge</label>
        <scitis-required-field-indicator></scitis-required-field-indicator>
        <ng-select (focusout)="onFocusOut()"
          [items]="SIGNAL_EDGE"
          [ngClass]="{ 'is-invalid': formControls.signalEdge.touched && formControls.signalEdge.errors}"
          bindLabel="name" bindValue="name" formControlName="signalEdge" id="signalEdge"
          placeholder="Select signal edge">
        </ng-select>
        @if (formControls.signalEdge.touched && formControls.signalEdge.errors) {
          <div class="invalid-feedback">
            @if (formControls.signalEdge.errors.required) {
              <span translate>Signal edge selection required</span>
            }
          </div>
        }
      </div>
    </div>
    <!--EXECUTION THRESHOLD-->
    @if (selectedTriggerType===triggerType.VALUE_BASED) {
      <div class="col-12 col-lg-4">
        <div class="form-group">
          <label for="executionThreshold" translate>Execution threshold [s]</label>
          <input (focusout)="onFocusOut()"
            [ngClass]="{ 'is-invalid': submitted && formControls.executionThreshold.errors }"
            class="form-control" formControlName="executionThreshold"
            id="executionThreshold" name="executionThreshold" type="number">
            @if (submitted && formControls.executionThreshold.errors) {
              <div class="invalid-feedback">
                @if (formControls.executionThreshold.errors.min || formControls.executionThreshold.errors.max) {
                  <span
                  translate>Threshold should be between 0 and 7200</span>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

    <scitis-admin-trigger-expression-table
      (deletedTriggerSignalExpression)="onDeleteTriggerExpression($event)"
      (deletedTriggerTimeExpression)="onDeleteTriggerExpression($event)"
      (updatedTriggerExpressions)="onUpdatedTriggerExpressions($event)"
      (updatedTriggerTimeExpressions)="onUpdatedTriggerTimeExpressions($event)"
      [gatewaySelected]="!!formControls.cloudPlug.value"
      [isAdminOrHigher]="isAdminOrHigher"
      [selectedTriggerType]="selectedTriggerType"
      [signals]="signals"
      [triggerExecutionInDataflow]="triggerExecutionInDataflow"
      [triggerSignalExpressions]="triggerSignalsExpressions"
      [triggerTimeExpressions]="triggerTimeExpressions">
    </scitis-admin-trigger-expression-table>


  </div>
